import { renderHotspot } from '../components/RenderHotspot';

export const InternalHotspots = onClick => {
  return [
    {
      pitch: -14,
      yaw: 0,
      cssClass: 'custom-hotspot',
      createTooltipFunc: renderHotspot,
      createTooltipArgs: {
        title: 'HD TFT INSTRUMENT CLUSTER',
        modal: 'cluster'
      },
      clickHandlerFunc: onClick,
      clickHandlerArgs: {
        pitch: -18.6,
        yaw: 7.9,
      }
    },
    {
      pitch: 3,
      yaw: 120,
      cssClass: 'custom-hotspot',
      createTooltipFunc: renderHotspot,
      createTooltipArgs: {
        title: 'LIGHTWEIGHT SLIMLINE SEATS',
        modal: 'seats'
      },
      clickHandlerFunc: onClick,
      clickHandlerArgs: {
        pitch: 3,
        yaw: 120,
      }
    },
    {
      pitch: -32,
      yaw: -95,
      cssClass: 'custom-hotspot',
      createTooltipFunc: renderHotspot,
      createTooltipArgs: {
        title: 'DOOR TRIM',
        modal: 'trim'
      },
      clickHandlerFunc: onClick,
      clickHandlerArgs: {
        pitch: -32,
        yaw: -95,
      }
    },
    {
      pitch: -18,
      yaw: 39,
      cssClass: 'custom-hotspot',
      createTooltipFunc: renderHotspot,
      createTooltipArgs: {
        title: 'INFOTAINMENT SYSTEM',
        modal: 'infotainment'
      },
      clickHandlerFunc: onClick,
      clickHandlerArgs: {
        pitch: -18,
        yaw: 39,
      }
    },
    {
      pitch: -27,
      yaw: 44,
      cssClass: 'custom-hotspot',
      createTooltipFunc: renderHotspot,
      createTooltipArgs: {
        title: 'MERIDIAN AUDIO',
        modal: 'meridian'
      },
      clickHandlerFunc: onClick,
      clickHandlerArgs: {
        pitch: -27,
        yaw: 44,
      }
    },
    {
      pitch: -13,
      yaw: 56,
      cssClass: 'custom-hotspot',
      createTooltipFunc: renderHotspot,
      createTooltipArgs: {
        title: '1935 DETAILING',
        modal: 'detailing'
      },
      clickHandlerFunc: onClick,
      clickHandlerArgs: {
        pitch: -13,
        yaw: 56,
      }
    },
  ];
};
